<template>
  <v-toolbar flat v-bind="$attrs" class="centralized-toolbar">
    <v-container py-0 bottom="0" fluid>
      <v-row dense justify="center">
        <v-col class="v-toolbar__content content-toolbar" style="height: 64px;">
          <slot></slot>
        </v-col>
      </v-row>
    </v-container>

    <v-progress-linear
      absolute
      bottom
      color="primary"
      height="2"
      :active="$store.state.loading"
      :indeterminate="true"
    ></v-progress-linear>
  </v-toolbar>
</template>

<script>
  export default {
    name: 'z-centralized-toolbar',

    props: {
      fluid: {
        type: Boolean,
        default: false
      },

      loading: {
        type: Boolean,
        default: false
      }
    },
  }
</script>

<style scoped lang="scss">
  .centralized-toolbar {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    width: 100%;
    position: sticky;
    top: 64px;
    z-index: 2;

    .content-toolbar {
      height: 64px;
      display: flex;
      gap: 8px;
    }
  }

  .actions-buttons {
    display: flex;
    align-items: center;
    gap: 8px;
  }

</style>
